import React from 'react';
import { useIntl } from 'react-intl';
import { components, OptionProps } from 'react-select';

import { Label } from '../Label';
import { Select } from '../Select';

import { useHandlerWhenClickedOutside } from '../../../hooks';
import { Icon } from '../Icon';
import * as S from './styles';
import { IProps } from './types';

const Control = ({ selectProps: { setMenuIsOpen }, menuIsOpen, value }) => {
  const intl = useIntl();
  return (
    <S.SortLine
      data-cy="dropdown-select-input"
      onClick={() => setMenuIsOpen(!menuIsOpen)}
    >
      <Label>
        {intl.formatMessage({
          defaultMessage: 'Sort by:',
          id: '40bnK/',
        })}
      </Label>
      <S.Value>{value?.label || ''}</S.Value>
      <S.Indicator rotate={String(menuIsOpen)}>
        <Icon name="select_arrow" size={10} />
      </S.Indicator>
    </S.SortLine>
  );
};

const IndicatorSeparator = () => null;

const IndicatorsContainer = () => null;

const Option = (props: OptionProps<any>) => <components.Option {...props} />;

export const DropdownSelect: React.FC<IProps> = ({
  options,
  name,
  value,
  onChange,
}: IProps) => {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);
  const { setElementRef } = useHandlerWhenClickedOutside(() => {
    setMenuIsOpen(false);
  });

  return (
    <S.Wrapper data-cy="dropdown-select" ref={setElementRef()}>
      <Select
        options={options}
        value={value}
        onChange={(valueProp) => {
          setMenuIsOpen(false);
          onChange(valueProp);
        }}
        name={name}
        menuIsOpen={menuIsOpen}
        setMenuIsOpen={setMenuIsOpen}
        components={{
          Control,
          IndicatorSeparator,
          IndicatorsContainer,
          Option,
        }}
      />
    </S.Wrapper>
  );
};
